import React, { useState, useEffect, useMemo } from "react";
import L from "leaflet";
import PropTypes from "prop-types";

// @material-ui/core components

import { Map, Marker, TileLayer } from "react-leaflet";

// import getCategories from "api/getCategories.js";
import searchNear from "api/search/search-near.js";
import SearchRestaurantCard from "componentCustom/SearchRestaurantCard.js";
import FooterContainer from "container/FooterContainer.js";

// const useStyles = makeStyles(styles);

export default function Search(props) {
  // const classes = useStyles();
  const {
    city,
    updateCity
    // , attributes
  } = props;
  const [list, setList] = useState([]);
  useEffect(() => {
    console.log("keowmefowomefompfewompwefompefwompewfomp");
    if (city && !city.latitude) {
      const searchQuery = window.location.search;
      const [latitude, longitude] = searchQuery.match(
        /([0-9]{0,2})+\.+([0-9]{0,9})/g
      );
      const [, name] = searchQuery.split("&");
      updateCity({ latitude, longitude, name: name.replace(/-/g, " ") });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (city && city.latitude) {
      searchNear(city.latitude, city.longitude)
        .then(res => setList(res || []))
        .catch(err => {
          console.log(err);
          return null;
        });
    }
  }, [city]);

  const { card, marker } = useMemo(() => {
    const card2 = [];
    const marker2 = [];
    list.forEach(el => {
      /*
          Start creation marker on map
        */
      const markerPlain = L.icon({
        iconUrl: `https://cdn.foodiestrip.com/pins/categories/category${el.categories[0]._id}-70.png`,
        iconSize: [35, 35],
        iconAnchor: [15, 34]
      });
      let lat = el.location.coordinates[1];
      let lng = el.location.coordinates[0];
      marker2.push(
        <Marker icon={markerPlain} key={el._id} position={{ lat, lng }} />
      );
      /*
          End creation marker on map
        */

      /*
          Start creation card on list
        */
      card2.push(
        <div className="search-results-card-container" key={el._id.toString()}>
          <SearchRestaurantCard
            restaurant={el}
            // attributes={attributes}
          />
        </div>
      );

      /*
          End creation card on list
        */
    });
    return { card: card2, marker: marker2 };
  }, [list]);

  return (
    <>
      <div className="page-map-container">
        <div className="page-map-restaurants-container">
          <div className="page-map-restaurants-container-title">
            Locali e ristoranti
          </div>
          <div className="page-map-restaurant-container-city">
            Scelti dai foodies a {city && city.name ? city.name : "Roma"}
          </div>
          {card}
        </div>
        <div className="page-map-map-container">
          <Map
            id={"cdc"}
            center={
              city.latitude && city.longitude
                ? [city.latitude, city.longitude]
                : [41.89193, 12.51133]
            }
            maxZoom={18}
            scrollWheelZoom={false}
            zoom={16}
            length={4}
            style={{
              width: "100%",
              height: "calc(100vh - 86px)",
              overflow: "hidden"
            }}
          >
            <TileLayer
              attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
              url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
            />
            {marker}
          </Map>
        </div>
      </div>
      <FooterContainer />
    </>
  );
}

Search.propTypes = {
  city: PropTypes.object.isRequired,
  updateCity: PropTypes.func.isRequired
  // attributes: PropTypes.object.isRequired
};
